// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagePreviewSpace_wrapper__ep5NL","image":"ImagePreviewSpace_image__qr3dX"};